<form [formGroup]="addOrEditForm" class="tablelist-form" autocomplete="off">
  <div [class.dropdown-label-left]="!labelTop">
    <label for="deviceID-field" class="form-label">Sim</label>
    <ng-select
      appendTo="body"
      bindLabel="description"
      bindValue="id"
      [clearable]="true"
      formControlName="deviceID"
      id="deviceID-field"
      [items]="getDropdownDataObjectArray()"
      [placeholder]="firstDeviceOption || ''"
      [searchable]="true"
      (change)="selectOnChange($event, $event?.description)"
    ></ng-select>
  </div>
</form>
